export const paymentStatus = {
  ACTIVE: 'active',
  PASSIVE: 'passive',
}
